export class PropertyTransactionTypesController {
    constructor(axios) {
        this.axios = axios;
    }
    async find() {
        try {
            const response = await this.axios.get("/property-transaction-types");
            return response.data;
        }
        catch (e) {
            throw e;
        }
    }
    async detail(id) {
        try {
            const response = await this.axios.get(`/property-transaction-types/${id}`);
            return response.data;
        }
        catch (e) {
            throw e;
        }
    }
}
